import React, { useEffect, useState } from "react";
import ViewNewInquiry from "./ViewNewInquiry";
import { Formik, FormikHelpers, Form } from "formik";
import {
  useUpdateQueryActionMutation ,
} from "src/services/InquiryServices";
import { useParams } from "react-router-dom";
import { useUpdateContactMutation, useViewSingleContactQuery , useGetOverViewListingQuery, useGetLifeCycleStageQuery } from "src/services/ContactServices";

const ViewNewInquiryWrapper = () => {
  const { contactId } = useParams();

  const [queryData, setQueryData] = useState<any>(); 
  const [followUpData , setFollowUpData] = useState<any>()
  const [updateQuery] = useUpdateContactMutation();

  const [updateQueryFollowUp , updateQueryFollowUpInfo] = useUpdateQueryActionMutation() 

  const {data:lifeCycleStageData} = useGetLifeCycleStageQuery('')

  const { data, isLoading, isFetching } = useViewSingleContactQuery(contactId, {
    skip: !contactId,
  });

 const lifeCycleStageOptions = lifeCycleStageData?.data?.map((el: any) => {
  return {
    label: el?.stageName,
    value : el?.stageName
  };
}); 

  const {
    data: actionData,
    isLoading: actionDataIsLoading,
    isFetching: actionDataIsFetching,
  } = useGetOverViewListingQuery(contactId); 

 useEffect(()=>{
   if(!actionDataIsLoading && !actionDataIsFetching){
    setFollowUpData(actionData?.data)
   }
 },[actionData ,actionDataIsLoading , actionDataIsFetching])

  useEffect(() => {
    if (!isLoading && !isFetching) {
      setQueryData(data?.data);
    }
  }, [data, isLoading, isFetching]);

  const initialValues = {
    inquiryLabel: queryData?.inquiryLabelId || "",
    lifeCycleStage: queryData?.lifecycleStage || "",
    newMessage: "",
    messageNote:''
  };
  const handleSubmit = (
    values: any,
    { setSubmitting, resetForm }: FormikHelpers<any>
  ) => {
    setTimeout(() => {
      setSubmitting(false);
      resetForm();
    }, 1000);
  };

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      onSubmit={handleSubmit}
    >
      {(formikProps) => (
        <Form className='overflow-hidden'>
          <ViewNewInquiry 
           followUpData={followUpData}
           isLoadingUpdateAction= {updateQueryFollowUpInfo?.isLoading}
            updateQuery={updateQuery}
            actionDataIsLoading={actionDataIsLoading || actionDataIsFetching}
            InquiryId={contactId}
            queryData={queryData}
            formikProps={formikProps} 
            updateQueryFollowUp={updateQueryFollowUp}
            lifeCycleStageOptions={lifeCycleStageOptions}
          />
        </Form>
      )}
    </Formik>
  );
};

export default ViewNewInquiryWrapper;
